import * as React from 'react';
import { SVGProps } from 'react';
export const ClassiqueVerticalSelected = (props: SVGProps<SVGSVGElement>) => (
    <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M2.898 45.6V2.4h43.2v43.2z" fill="#13123A" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 48V0h48v48zm2.4-2.4h43.2V2.4H2.9z" fill="#fff" />
        <path
            d="M10.1 10.8h4.8V2.4h2.4V24h6V13.2h-.001V2.4H25.7v8.4h4.8V2.4h2.4V24h4.8V2.4h2.4v8.4h6v2.4h-6V36h6v2.4h-6v7.2h-2.4V26.4h-4.8v19.2h-2.4v-7.2h-4.8v7.2h-2.4V26.4h-6v19.2h-2.4v-7.2h-4.8v7.2H7.7V26.4h-6V24h6V2.4h2.4zm0 25.201h4.8v-22.8h-4.8zM25.7 36h4.8V13.2h-4.8z"
            fill="#fff"
        />
    </svg>
);
